<template>
  <div>
    <div class="d-flex toolbar justify-content-between mb-4">
      <h4 class="text-color-4">
        {{ $t("settings.shipping_method_settings") }}
      </h4>
    </div>
    <div v-if="loading">
      <Spinner size="sm" />
    </div>
    <div v-else>
      <!-- ThaipostUser form  -->
      <ValidationObserver v-slot="{ invalid }">
        <!-- <div v-if="thaipostInfoFilled">
              <table class="table table-sm">
                <tr>
                  <td>{{ $t("settings.thaipost.username") }}:</td>
                  <td>{{ shipmentForm.username }}</td>
                </tr>
                <tr>
                  <td>{{ $t("settings.thaipost.password") }}:</td>
                  <td>{{ shipmentForm.password | password }}</td>
                </tr>
                <tr>
                  <td>{{ $t("settings.thaipost.license_no") }}:</td>
                  <td>{{ shipmentForm.licenseNo }}</td>
                </tr>
                <tr>
                  <td>{{ $t("settings.thaipost.prefix") }}:</td>
                  <td>{{ shipmentForm.prefix }}</td>
                </tr>
                <tr>
                  <td>{{ $t("settings.thaipost.prefix_type") }}:</td>
                  <td>{{ shipmentForm.prefixType }}</td>
                </tr>
              </table>
            </div> -->

        <form @submit.prevent="handleFormSubmit">

          <div class="row">
            <div class="col-3">
              ชื่อผู้ใช้
            </div>
            <div class="col-9">
              <TextBox type="text"
                       id="username"
                       v-model="shipmentForm.username" />
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              รหัสผ่าน
            </div>
            <div class="col-9">
              <TextBox type="password"
                       id="password"
                       v-model="shipmentForm.password" />
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              เลขที่ใบอนุญาต
            </div>
            <div class="col-9">
              <TextBox type="text"
                       id="licenseNo"
                       v-model="shipmentForm.licenseNo" />
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              {{ $t('settings.thaipost.prefix') }}
            </div>
            <div class="col-9">
              <TextBox type="text"
                       id="prefix"
                       v-model="shipmentForm.prefix" />
            </div>
          </div>

          <div class="text-center mt-5">
            <Button id="emsThaiPostFormSubmitBtn"
                    variant="primary"
                    size="md"
                    custom_class="btn-block"
                    :loading="formLoading"
                    :disabled="formLoading || invalid">
              {{ $t("general.update") }}
            </Button>
          </div>
        </form>

      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Card from "@/components/core/Card";
import Spinner from "@/components/core/Spinner";
import Button from "@/components/core/Button";
import TextBox from "@/components/core/TextBox";

export default {
  name: "SellerSettingsShipping",
  components: {
    Card,

    Spinner,
    Button,
    TextBox,
  },
  data() {
    return {
      loading: false,
      formLoading: false,
      shipmentForm: {
        username: null,
        password: null,
        licenseNo: null,
        prefix: null,
        prefixType: null,
      }
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {

    async fetchData() {
      this.loading = true;
      const { status, data } = await this.$store.dispatch("settings/fetchSetting", { type: "shipping" });
      if (status) this.shipmentForm = data
      this.loading = false;
    },

    async handleFormSubmit() {
      this.formLoading = true;
      const { status } = await this.$store.dispatch("settings/updateSetting", {
        type: "shipping",
        data: {
          username: this.shipmentForm.username,
          password: this.shipmentForm.password,
          licenseNo: this.shipmentForm.licenseNo,
          prefix: this.shipmentForm.prefix,
          prefixType: this.shipmentForm.prefixType,
        }
      });
      this.formLoading = false;
    }
  }
};
</script>
